let editorProofreadPromptOverride = "";

try {
  localStorage.removeItem("editor_proofread_system_prompt");
} catch {
  // ignore
}

export function readEditorProofreadPromptOverride(): string {
  return editorProofreadPromptOverride.trim();
}

export function writeEditorProofreadPromptOverride(prompt: string): void {
  editorProofreadPromptOverride = String(prompt ?? "").trim();
}
